export default __webpack_public_path__ + "static/media/pos.03bb833d.svg";